"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onInput: function ({label, instructions, options}) {
        if (!label || !options)
            return console.log('[Context-Modal] Invalid Parameters');
        if (Array.isArray(options))
            options = { __: options };
        this.setState({
            label,
            instructions,
            options
        });
    },
    onSelect: function (option) {
        this.emit('select', option);
        this.emit('dismiss');
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/components/ContextModal/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Locale_template = require("../Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forIn = require("marko/dist/runtime/helpers/for-in"),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    WSAdapt_template = require("../WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Row_template = require("../Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_attrs0 = {
        "class": "context-modal position-absolute zindex-4 w-100 h-100 top-0 left-0 d-flex align-items-center center"
      },
    marko_attrs1 = {
        "class": "py-1"
      },
    marko_attrs2 = {
        "class": "text-primary font-small-3 pb-1"
      },
    marko_attrs3 = {
        "class": "btn btn-outline-secondary btn-lg m-25"
      },
    marko_attrs4 = {
        "class": "position-fixed top-0 w-100 h-100 theme-bg-transparent animated fadeIn faster"
      },
    marko_attrs5 = {
        "class": "text-muted"
      };

function render(input, out, __component, component, state) {
  var data = input;

  function macro_Group(out, { group }) {
    out.be("div", marko_attrs1, "0", component);

    if (group.name !== "__") {
      out.e("div", marko_attrs2, "1", component, 1)
        .t(group.name.toCapitalCase(), component);
    }

    marko_forOf(group.options, function(option, index) {
      out.e("button", marko_attrs3, "@" + index, component, 1, 0, {
          onclick: __component.d("click", "onSelect", false, [
              option
            ])
        })
        .t(option.label, component);
    });

    out.ee();
  }

  out.be("div", marko_attrs0, "2", component);

  Row_tag({
      class: "m-0 w-100 d-flex justify-content-center",
      renderBody: function(out) {
        out.e("div", marko_attrs4, "4", component, 0, 0, {
            onclick: __component.d("click", () => component.emit('dismiss'), false)
          });

        WSAdapt_tag({
            ns: "col-md-4 col-10",
            qs: "col-md-6 col-10",
            hs: "col-md-9 col-10",
            class: "animated zoomIn faster",
            style: "padding-bottom:150px",
            renderBody: function(out) {
              out.be("h5", null, "6", component);

              Locale_tag({
                  text: input.label
                }, out, __component, "7");

              out.ee();

              if (input.instructions) {
                out.be("p", marko_attrs5, "8", component);

                Locale_tag({
                    text: input.instructions
                  }, out, __component, "9");

                out.ee();
              }

              marko_forIn(input.options, function(name, options) {
                marko_dynamicTag(out, macro_Group, function() {
                  return {
                      group: {
                          name: name,
                          options: options
                        }
                    };
                }, null, null, null, __component, name);
              });
            }
          }, out, __component, "5");
      }
    }, out, __component, "3");

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
